/**
 * Audit events, in words a parent reads rather than event codes.
 *
 * The console is only oversight if it is legible at a glance, so blocks and
 * failures are phrased plainly and are visually distinct from ordinary activity.
 */
export const EVENT_LABELS: Record<string, string> = {
  JAM_STARTED: 'Started a jam',
  JAM_SHIPPED: 'Shipped a game at the buzzer',
  JAM_ENDED_EMPTY: 'Jam ended with nothing built',
  BUILD_READY: 'Built a game',
  BUILD_BLOCKED: 'A generated game was blocked',
  BRIEF_BLOCKED: 'An idea was blocked before building',
  GATE_DENIED: 'Asked to build but was not allowed',
  KID_SUSPENDED_BY_PARENT: 'You paused this account',
  KID_RESUMED: 'You resumed this account',
  DEVICE_TOKEN_ISSUED: 'You set up a device',
  DEVICE_TOKENS_REVOKED: 'You signed this child out everywhere',
  CAP_CHANGED: 'You changed the monthly spending cap',
};

/** Events a parent should actually look at, rather than scroll past. */
export const NOTABLE = new Set(['BUILD_BLOCKED', 'BRIEF_BLOCKED']);

export const labelFor = (event: string): string => EVENT_LABELS[event] ?? event;
